/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/games/search': {
    width: 16,
    height: 16,
    viewBox: '0 0 60 60',
    data: '<circle pid="0" cx="20" cy="20" r="19"/><path pid="1" d="M31 35l20 20a1 1 0 004-4L35 31m-1 7l4-4"/><path pid="2" d="M20 3A17 17 0 004 14m-.8 3.4a17 17 0 00-.1.6" stroke-linecap="round"/><path pid="3" d="M5 26l5-6 5 14 5-24 5 16 5-16 5 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
